import { useEffect } from "react";
import { Link } from "wouter";
import { useI18n } from "../lib/i18n";
import { resetMeta, setMeta } from "../lib/seo";

export default function PricingComingSoon() {
  const { t } = useI18n();

  useEffect(() => {
    setMeta({
      title: "Pricing — Coming Soon | KontrataPH",
      description: "Our pricing page is on its way! In the meantime, explore KontrataPH and find your next opportunity.",
    });
    return resetMeta;
  }, []);

  return (
    <section
      aria-labelledby="pricing-coming-soon-title"
      className="coming-soon flex min-h-[412px] flex-1 items-center justify-center bg-[#052253] bg-cover bg-center px-6 py-20 text-center text-white"
      style={{ backgroundImage: 'linear-gradient(rgba(5, 34, 83, 0.65), rgba(5, 34, 83, 0.65)), url("/pricing-business-district.png")' }}
    >
      <div className="w-full max-w-[560px]">
        <h1 id="pricing-coming-soon-title" className="text-4xl font-bold leading-tight sm:text-[44px]">{t("pricing.comingSoon.title")}</h1>
        <p className="mt-3 text-[15px] leading-[18px]">{t("pricing.comingSoon.description")}</p>
        <Link href="/marketplace" className="mt-11 inline-flex min-h-[42px] items-center justify-center rounded-full bg-[#ed332b] px-[35px] text-xs font-semibold transition-colors hover:bg-[#cf2922] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white">
          {t("pricing.comingSoon.explore")}
        </Link>
      </div>
    </section>
  );
}
